import service from '../../utility/service';
import { errorOccurred } from '../../errors/reducer';

const INITIAL_STATE = {
  traders: undefined,
  fetching: false,
};

const types = {
  ADDED_TRADER: 'orb/admin/traders/ADDED_TRADER',
  FETCHING_TRADERS: 'orb/admin/traders/FETCHING_TRADERS',
  FETCHING_POTENTIAL_TRADERS: '/orb/admin/traders/FETCHING_POTENTIAL_TRADERS',
  RECEIVED_TRADERS: 'orb/admin/traders/RECEVIED_TRADERS',
  REMOVED_TRADER: 'orb/admin/traders/REMOVED_TRADER',
  UPDATED_TRADER: 'orb/admin/traders/UPDATED_TRADER',
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.FETCHING_TRADERS:
      return Object.assign({}, state, {
        fetching: true
      });
    case types.RECEIVED_TRADERS:
      return Object.assign({}, state, {
        fetching: false,
        traders: action.traders
      });
    case types.ADDED_TRADER:
      return Object.assign({}, state, {
        traders: state.traders
          .concat([action.trader])
          .sort(traderCompare)
      });
    case types.UPDATED_TRADER:
      return Object.assign({}, state, {
        traders: state.traders
          .filter(t => t.Id !== action.trader.Id)
          .concat([action.trader])
          .sort(traderCompare)
      });
    case types.REMOVED_TRADER:
      return Object.assign({}, state, {
        traders: state.traders
          .filter(t => t.Id !== action.id)
          .concat()
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

function fetchingTraders() {
  return { type: types.FETCHING_TRADERS };
}

function receivedTraders(traders) {
  return {
    type: types.RECEIVED_TRADERS,
    traders
  };
}

function removedTrader(id) {
  return {
    type: types.REMOVED_TRADER,
    id
  };
}

function updatedTrader(trader) {
  return {
    type: types.UPDATED_TRADER,
    trader
  };
}

function addedTrader(trader) {
  return {
    type: types.ADDED_TRADER,
    trader
  };
}

function shouldFetchTraders(state) {
  return !state.fetching && !state.traders;
}

export function removeTrader(trader) {
  return (dispatch) => {
    const id = trader.Id;
    return service.delete(`/Admin/Traders/${id}`).then(() => {
      dispatch(removedTrader(id));
    }).catch((err) => {
      dispatch(errorOccurred(err, `Deleting trader ${id}`));
      throw err;
    });
  };
}

export function fetchTradersIfNeeded() {
  return (dispatch, getState) => {
    const state = getState().admin.traders;
    if (shouldFetchTraders(state)) {
      dispatch(fetchingTraders());

      return fetchTraders().then((traders) => {
        dispatch(receivedTraders(traders));
      }).catch((err) => {
        dispatch(errorOccurred(err, 'Getting traders'));
        dispatch(receivedTraders([]));
      });
    }
    // Nothing to wait for
    return Promise.resolve();
  };
}

function fetchTraders() {
  return service.get('/Admin/Traders')
    .then((tradersResponse) => {
      const traders = tradersResponse.data.sort(traderCompare);
      return traders;
    });
}

function traderCompare(a, b) {
  return a.Name.localeCompare(b.Name);
}

export function addTrader(potentialTrader) {
  return (dispatch) => {
    const { UserPrincipalName, Name } = potentialTrader;
    const newTrader = { UserPrincipalName, Name, Active: true };
    return service.post('/Admin/Traders', newTrader).then((response) => {
      dispatch(addedTrader(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Adding trader'));
    });
  };
}

export function fetchPotentialTraders(searchInput) {
  return (dispatch) => {
    dispatch(fetchingPotentialTraders(searchInput));
    return service.get(`/Admin/PotentialTraders/${searchInput}`);
  };
}

function fetchingPotentialTraders(input) {
  return {
    type: types.FETCHING_POTENTIAL_TRADERS,
    input
  };
}

export function setTraderActive(trader, isActive) {
  return (dispatch) => {
    const modifiedTrader = Object.assign({}, trader, { Active: isActive });
    const id = modifiedTrader.Id;
    return service.put(`/Admin/Traders/${id}`, modifiedTrader).then((response) => {
      dispatch(updatedTrader(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Updating trader'));
    });
  };
}




// WEBPACK FOOTER //
// ./src/admin/traders/reducer.js